import script from "./PhoneNumberView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneNumberView.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneNumberView.vue?vue&type=style&index=0&id=de6d926a&scoped=true&lang=scss"

import exportComponent from "../../../../../home/franc/adereso-bsp-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de6d926a"]])

export default __exports__